import Moment from 'moment';
import PdfGenerator from './PdfGenerator';

class CommesseElenco extends PdfGenerator {

    constructor(){
        super();
        this.doDrawCell = this.doDrawCell.bind(this);
    }

    doDrawCell(cell, data){
        if (data.column.dataKey === 'colore'){
            cell.styles.textColor = cell.raw;
        }
    }

    createPdf(items){

        const columns = [
            {title: "ID", dataKey: "id"},
            {title: "Codice", dataKey: "codice"},
            {title: "Nome", dataKey: "nome"},
            {title: "Cliente", dataKey: "cliente"},
            {title: "Oggetto", dataKey: "ogg"},
            {title: "Note", dataKey: "note"},
            {title: "Incarico", dataKey: "dtincarico"},
            {title: "Altre date", dataKey: "date"},
            {title: "Peso", dataKey: "peso"},
            {title: "Incasso\npresunto", dataKey: "incasso"},
            {title: "Conclusa", dataKey: "chiusa"},
            {title: "Archiviata", dataKey: "archiviata"},
        ];
        let rows = [];
        items.map((item) => {
            let infoGara = item.idGara? ' (Gara:' + item.idGara.anno + '/' + item.idGara.codice + ')' :'';
            let elencoDate =
                (item.dataInizioPrestazione !== null ? 'Inizio prest: ' + Moment(item.dataInizioPrestazione).format('DD/MM/YYYY') : '') + ' ' +
                (item.dataFinePrestazione!== null ? 'Fine prest: ' + Moment(item.dataFinePrestazione).format('DD/MM/YYYY') : '') + ' ' +
                (item.dataChiusura!== null ? 'Chiusura: ' + Moment(item.dataChiusura).format('DD/MM/YYYY') : '');
            let clienteDesc = (item.ragioneSociale ? item.ragioneSociale : '') + '\n' +
                (item.indirizzo ?  item.indirizzo : '' )+ ' ' +
                (item.cap ? item.cap : '') + ' ' +
                (item.citta ? item.citta : '') + ' ' +
                (item.provincia ? item.provincia : '') + ' ' +
                (item.stato ? item.stato : '') + '\n' +
                (item.piva ? 'p.iva:' + item.piva : '') + ' ' +
                (item.cfisc ? 'c.f.:' + item.cfisc : '');
            let it = {
                id: item.idCommessa,
                codice: item.codice,
                nome: item.nome + infoGara,
                cliente: clienteDesc.trim(),
                ogg: (item.oggetto ? item.oggetto : ''),
                note: (item.note ? item.note : ''),
                dtincarico: (item.dataIncarico !== null ? Moment(item.dataIncarico).format('DD/MM/YYYY') : ''),
                date:  elencoDate.trim(),

                peso: item.peso,
                incasso: this.formatCurrency(item.incassoPresunto),
                chiusa: item.conclusa ? 'SI': 'NO',
                archiviata: item.archiviata ? 'SI': 'NO',
            };
            rows.push(it);
            return 0;
        });

        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 7,
                },
                columnStyles: {
                    nome: {halign: 'left', columnWidth: 90},
                    codice: {halign: 'left'},
                    cliente: {halign: 'left',columnWidth: 120},
                    ogg: {halign: 'left',columnWidth: 120},
                    note: {halign: 'left',columnWidth: 120},
                    dtincarico: {halign: 'center'},
                    date: {halign: 'left',columnWidth: 100},
                    peso: {halign: 'center'},
                    chiusa: {halign: 'center'},
                    archiviata: {halign: 'center'},
                    incasso: {halign: 'right'},
                }
            });
    }


}

export default CommesseElenco;


/** WEBPACK FOOTER **
 ** ./src/pdf/CommesseElenco.js
 **/